/**
 * @description
 */
export default function required(value) {
    return !!value || value === 0 || 'Campo obligatorio.'
}
